<ion-grid [fixed]="true">
  <ion-row>
    <ion-col size="12" size-md="6" class="sizes-wrapper">
      <ion-radio-group [(ngModel)]="selectedPaperSize">
        <ion-grid [fixed]="true">
          <ion-row>
            @for (paperSize of paperSizes(); track paperSize.id) {
            <ion-col size="6">
              <app-option-selector
                [small]="true"
                [name]="paperSize.name"
                [descriptionString]="paperSize.width + ' x ' + paperSize.height + 'mm'"
                [item]="paperSize"
                [isSelected]="paperSize == selectedPaperSize()"
                (click)="onPaperSizeClick(paperSize)"
                (dblclick)="onDoubleClick()">
              </app-option-selector>
            </ion-col>
            }
          </ion-row>
        </ion-grid>
      </ion-radio-group>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="a0 A top-bottom" [class.selected]="selectedPaperSizeType() == paperSizeType.A0">
        <div
          class="a1 A"
          [class.selected]="selectedPaperSizeType() == paperSizeType.A1"
          (click)="onPaperSizeBoxClick(paperSizeType.A1)">
          <ion-text class="paper-size-text" color="primary"><h2>A1</h2></ion-text>
        </div>
        <div class="A left-right">
          <div class="a2 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A2"
            (click)="onPaperSizeBoxClick(paperSizeType.A2)">
            <ion-text class="paper-size-text" color="primary"><h2>A2</h2></ion-text>
          </div>
          <div class="A top-bottom">
            <div class="a3 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A3"
              (click)="onPaperSizeBoxClick(paperSizeType.A3)">
              <ion-text class="paper-size-text" color="primary"><h2>A3</h2></ion-text>
            </div>
            <div class="A left-right">
              <div class="a4 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A4"
                (click)="onPaperSizeBoxClick(paperSizeType.A4)">
                <ion-text class="paper-size-text" color="primary"><h3>A4</h3></ion-text>
              </div>
              <div class="A top-bottom">
                <div class="a5 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A5"
                  (click)="onPaperSizeBoxClick(paperSizeType.A5)">
                  <ion-text class="paper-size-text" color="primary"><h4>A5</h4></ion-text>
                </div>
                <div class="A left-right">
                  <div class="a6 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A6"
                    (click)="onPaperSizeBoxClick(paperSizeType.A6)">
                    <ion-text class="paper-size-text" color="primary"><h5>A6</h5></ion-text>
                  </div>
                  <div class="A top-bottom">
                    <div class="a7 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A7"
                      (click)="onPaperSizeBoxClick(paperSizeType.A7)">
                      <ion-text class="paper-size-text" color="primary"><h5>A7</h5></ion-text>
                    </div>
                    <div class="A left-right">
                      <div class="a8 A" [class.selected]="selectedPaperSizeType() == paperSizeType.A8"
                        (click)="onPaperSizeBoxClick(paperSizeType.A8)">
                        <ion-text class="paper-size-text" color="primary"><h5>A8</h5></ion-text>
                      </div>
                      <div class="A"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
